module.exports = "/images/clock.png?648404c960010e816002a1623c6cdd33";